<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="list mtb80">
                    <div class="ctrl_bar right">
                        <div class="input_box">
                            <select v-model="matching">
                                <option value="">매칭여부</option>
                                <option value="매칭">매칭</option>
                                <option value="미매칭">미매칭</option>
                            </select>
                        </div>
                        <button
                          v-if="user && user.level == 1"
                          class="buttn"
                          type="button"
                          onclick="window.location.href='/maintenance_write';"
                        >
                          유지관리 문의하기
                        </button>
                    </div>
                    <div class="table">
                        <table>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>제목</th>
                                    <th>등록날짜</th>
                                    <th>매칭요청날짜</th>
                                    <th>매칭날짜</th>
                                    <th>매칭여부</th>
                                    <th>매칭요청</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in list" :key="row.id">
                                    <td>{{ pagination.total - ((pagination.current_page - 1) * pagination.per_page) - index }}</td>
                                    <td>
                                        <a :href="`/maintenance_view?id=${row.id}`">
                                            {{ row.title }}
                                        </a>
                                    </td>
                                    <td>{{ formatDate(row.created_at) }}</td>
                                    <td>
                                      <span v-if="row.request_count > 0 && getMatchingText(row.mstatus) === '매칭'">
                                        {{ formatDate(row.request_created_at) }}
                                      </span>
                                      <span v-else>-</span>
                                    </td>
                                    <td>
                                      <span v-if="row.request_count > 0 && getMatchingText(row.mstatus) === '매칭'">
                                        {{ formatDate(row.maintenence_date) }}
                                      </span>
                                      <span v-else>-</span>
                                    </td>
                                    <td>
                                        <span
                                            :class="getMatchingText(row.mstatus) === '매칭'
                                                ? 'state blue_f bluee_bg'
                                                : 'state red_f reed_bg'">
                                            {{ getMatchingText(row.mstatus) }}
                                        </span>
                                    </td>
                                    <td>{{ row.request_count || 0 }}건</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="pagination" v-if="pagination && pagination.last_page > 1">
                        <!-- 이전 -->
                        <a href="#" class="prev"
                            @click.prevent="goPage(pagination.current_page - 1)"
                            v-if="pagination.current_page > 1">
                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.45 12.08">
                                <path d="M.71,11.37l5.33-5.33L.71.71"
                                      fill="none" stroke="#1b1e23" stroke-width="2"/>
                            </svg>
                         </a>

                         <!-- 페이지 번호 -->
                         <a href="#"
                            v-for="p in pagination.last_page"
                            :key="p"
                            :class="{ active: p === pagination.current_page }"
                            @click.prevent="goPage(p)">
                             {{ p }}
                         </a>

                         <!-- 다음 -->
                         <a href="#" class="next"
                            @click.prevent="goPage(pagination.current_page + 1)"
                            v-if="pagination.current_page < pagination.last_page">
                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.45 12.08">
                                <path d="M.71,11.37l5.33-5.33L.71.71"
                                      fill="none" stroke="#1b1e23" stroke-width="2"/>
                            </svg>
                         </a>
                     </div>
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
import api from '@/api'
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
    name: 'MaintenancePage',
    components: { TheHeader, TheFooter },

    data() {
        return {
            user: null,
            list: [],
            matching: '',
            pagination: null,
            page: 1    
        }
    },

    mounted() {
        this.checkLoginAndLoad()
    },

    watch: {
        matching() {
            this.page = 1
            this.loadMaintenance()
        }
    },

    methods: {
        /* 로그인 체크 */
        async checkLoginAndLoad() {
            try {
                const res = await api.get('/admin/user-info', {
                    withCredentials: true
                })

                if (!res.data.loggedIn) {
                    this.redirectLogin()
                    return
                }

                this.user = res.data.user
                this.loadMaintenance()

            } catch (e) {
                this.redirectLogin()
            }
        },

        redirectLogin() {
            const referer = this.$route.fullPath
            window.location.href =
                `/login_form?referer=${encodeURIComponent(referer)}`
        },

        /* 유지관리 목록 조회 */
        async loadMaintenance() {
            try {
                const res = await api.get('/admin/vue_maintenance_list', {
                    params: {
                        username: this.user.username,
                        level: this.user.level,
                        matching: this.matching,
                        page: this.page
                    },
                    withCredentials: true
                })

                this.list = res.data.data || []
                this.pagination = res.data

            } catch (e) {
                console.error(e)
            }
        },

        formatDate(date) {
            return date ? date.substring(0, 10) : '-'
        },

        /* 매칭/비매칭 텍스트 변환 */
        getMatchingText(mstatus) {
            return ['업체매칭', '수리검사', '완료'].includes(mstatus)
                ? '매칭'
                : '미매칭'
        },

        goPage(page) {
            if (page < 1 || page > this.pagination.last_page) return
            this.page = page
            this.loadMaintenance()
        }
    }
}
</script>    